{
  "guidance": {
    "tours": {
      "T02": {
        "title": "ابحث عن الأصناف وجهّز طلب الشراء",
        "summary": "ابحث في الكتالوج، واطّلع على شروط الصنف، وجهّز السلة للمراجعة.",
        "openCart": "افتح «السلة» من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "search": {
          "title": "ابحث في الكتالوج",
          "body": "ابحث بالعربية أو الإنجليزية، وضيّق القائمة بعوامل التصفية المتاحة لدورك. لا تظهر إلا الأصناف المعتمدة لوحدة الشراء الخاصة بك."
        },
        "itemFacts": {
          "title": "اطّلع على شروط الصنف",
          "body": "يعرض كل صنف سعره وعبوته وضريبته وأقل كمية للطلب ومدة التوريد، كما تحددها الاتفاقية. وإن تعذّر طلب الصنف هنا، توضّح بطاقته السبب."
        },
        "add": {
          "title": "أضف إلى السلة",
          "body": "أدخل الكمية، ثم أضف الصنف إلى سلتك. قد تضم السلة الواحدة أصنافًا من عدة موردين بعملة واحدة. لا تضيف الجولة شيئًا نيابةً عنك."
        },
        "offCatalogue": {
          "title": "لم تجد ما تحتاجه في الكتالوج؟",
          "body": "صِف احتياجك وسيتولى قسم المشتريات توفيره. لا تختار المورد ولا السعر."
        },
        "cartLines": {
          "title": "السلة",
          "body": "يعرض كل بند سعره وكميته. السعر والمورد يحددهما المقر الرئيسي ولا يمكن تعديلهما هنا. وتُحفظ الكمية التي تغيّرها عند مغادرة الحقل."
        },
        "cartDetails": {
          "title": "تاريخ الاحتياج ومبرر الطلب",
          "body": "حدّد متى تحتاج الأصناف ولماذا. يُحفظ كلٌّ منهما عند مغادرة الحقل."
        },
        "review": {
          "title": "المراجعة والإرسال",
          "body": "تعرض «المراجعة والإرسال» الكميات وتاريخ الاحتياج وحالة الميزانية ومسار الاعتماد المتوقع. الإرسال من هناك ينشئ طلب شراء فعليًا، وأنت من يرسله."
        }
      },
      "T03": {
        "title": "تابِع طلباتك وصحّحها وأعد طلبها",
        "summary": "اعثر على طلباتك، واعرف لدى من يوجد كلٌّ منها، وعدّل الطلب المُعاد، وأعد طلب ما سبق.",
        "openRequest": "افتح أحد طلباتك من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "filters": {
          "title": "اعثر على طلب",
          "body": "ضيّق القائمة حسب الحالة أو وحدة الشراء أو التاريخ. تبقى التصفية في عنوان الصفحة، فيعيدك زر الرجوع إلى القائمة نفسها."
        },
        "list": {
          "title": "أين وصل كل طلب",
          "body": "يعرض كل صف الحالة وما سيحدث بعد ذلك. افتح الطلب لترى سجله كاملًا، بما فيه من لديه الطلب الآن."
        },
        "nextAction": {
          "title": "ما الخطوة التالية",
          "body": "يوضّح هذا السطر الخطوة التالية ومن لديه الطلب. وإذا أعاده المعتمِد للتعديل، تظهر تعليماته هنا."
        },
        "tabs": {
          "title": "سجل الطلب",
          "body": "لكلٍّ من الأصناف ومسار الاعتماد والأثر على الميزانية وسجل الطلب تبويب خاص. ويعرض مسار الاعتماد كل قرار مع سببه."
        },
        "amend": {
          "title": "عدّل الطلب المُعاد",
          "body": "إذا أُعيد الطلب للتعديل، يفتحه «تعديل الطلب» مع تعليمات المعتمِد. بعد تعديلك يُفحص الطلب من جديد، ثم تعيد إرساله للاعتماد."
        },
        "reorder": {
          "title": "إعادة الطلب",
          "body": "تنسخ «إعادة الطلب» أصناف هذا الطلب إلى سلتك بأسعار اليوم وشروطه. وما لم يعد متاحًا للطلب يظهر فيها. وأنت من يعيد الطلب."
        },
        "reorderAbsent": "تُتاح «إعادة الطلب» بعد إرسال الطلب. وهذا الطلب ما زال مسودة، فلا يوجد فيه ما يُعاد طلبه بعد."
      },
      "T04": {
        "title": "راجع طلبًا بانتظار اعتمادك",
        "summary": "قائمة الاعتمادات، وما تراجعه في الطلب، والقرارات الأربعة.",
        "openApproval": "افتح طلبًا من قائمة الاعتمادات، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "inbox": {
          "title": "بانتظار قرارك",
          "body": "لا تظهر هنا إلا الطلبات التي بلغت مستواك الآن أو فُوّضت إليك، ويذكر الطلب المفوَّض ممن التفويض وحتى متى. يعرض كلٌّ منها المبلغ والمستوى ووضع الميزانية وموعد الاستحقاق وأي استثناءات. افتح أحدها لاتخاذ القرار."
        },
        "why": {
          "title": "سبب التوجيه",
          "body": "القاعدة التي وجّهت هذا الطلب إليك، وأي استثناء ينبغي مراجعته قبل أن تقرر."
        },
        "lines": {
          "title": "البنود والكميات",
          "body": "ما يُطلب شراؤه بندًا بندًا. الاعتماد الجزئي يخفّض الكمية فقط ولا يزيدها."
        },
        "budget": {
          "title": "الأثر على الميزانية",
          "body": "الميزانية التي يستهلك منها الطلب وما سيتبقى منها. الرقابة على الميزانية تنبيهية: التجاوز يغيّر مسار الاعتماد ولا يمنع الطلب."
        },
        "workflow": {
          "title": "مسار الاعتماد",
          "body": "كل مستوى، ومن اتخذ قراره حتى الآن، ومن يقرر بعدك."
        },
        "decide": {
          "title": "قرارك",
          "body": "اعتماد، أو اعتماد جزئي، أو إعادة للتعديل، أو رفض. ويتطلب كلٌّ من الاعتماد الجزئي والإعادة والرفض ذكر السبب. وإذا قررت نيابةً عن غيرك يُسجَّل القرار باسمَيكما. اختيار القرار يفتح تأكيده، وأنت من يُتمّه."
        }
      },
      "T05": {
        "title": "توريد احتياج من خارج الكتالوج",
        "summary": "من الاحتياج في قائمة التوريد إلى طلب العروض وعروض الموردين وقرار الترسية.",
        "openForm": "اختر «بدء طلب عروض» لاحتياج في قائمة التوريد، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "openEnquiry": "افتح طلب عروض من قائمة التوريد، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "queue": {
          "title": "قائمة التوريد",
          "body": "الاحتياجات المُحالة إلى التوريد وطلبات العروض المنشأة لها في قائمة واحدة. يفتح «بدء طلب عروض» نموذج الطلب، ولا يُنشأ شيء حتى تؤكد هناك."
        },
        "lines": {
          "title": "ما تطلبه",
          "body": "يطلب طلب العروض بنود الاحتياج وكمياته. لا تحدد هنا موردًا ولا سعرًا، فالموردون هم من يقدّمون أسعارهم."
        },
        "draft": {
          "title": "مسودة أولًا",
          "body": "إنشاء طلب العروض يحفظه مسودة، ولا يصل شيء إلى أي مورد حتى تفتحه."
        },
        "suppliers": {
          "title": "الموردون المدعوون",
          "body": "في المسودة، اختر الموردين المؤهلين الذين تدعوهم. وبعد فتح الطلب يظهر كل مورد مدعو مع حالة رده. ولا يرى كل مورد إلا دعوته."
        },
        "open": {
          "title": "فتح طلب العروض",
          "body": "يدعو الفتح الموردين المختارين ويتيح لهم الرد حتى الموعد النهائي. بعدها يعرض الطلب رقمه والموعد النهائي وعدد الموردين الذين ردّوا. وأنت من يفتحه عندما يكون جاهزًا."
        },
        "comparison": {
          "title": "مقارنة العروض",
          "body": "عرض كل مورد والحقائق نفسها جنبًا إلى جنب. لا يقيّمها فيدلِن ولا يرتّبها — القرار قرارك."
        },
        "decision": {
          "title": "تسجيل قرارك",
          "body": "اختر الترسية على المورد المختار أو الإغلاق دون ترسية، وكلاهما يتطلب ذكر السبب. الترسية تحوّل العرض الفائز إلى بيانات شراء معتمدة، ولا تُنشئ أمر شراء ولا تلتزم بأي ميزانية. وأنت من يسجّله."
        }
      },
      "T06": {
        "title": "تابِع أمر الشراء وأدِره",
        "summary": "إصدار الأمر وحالاته الأربع المنفصلة، وردود المورد والاستلامات، وما يترتب على تعديله أو إلغائه.",
        "openOrder": "افتح أمرًا من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "list": {
          "title": "أوامر الشراء",
          "body": "يعرض كل أمر مورده ووحدة الشراء وموعد الحاجة إليه، ووضعه في أربعة أعمدة: الأمر، والمورد، والتسليم، والفوترة. افتح الأمر لترى سجله."
        },
        "header": {
          "title": "الأمر",
          "body": "رقم الأمر وإصداره الحالي، والطلب الذي نشأ منه، والمورد الموجّه إليه."
        },
        "status": {
          "title": "أربع حالات منفصلة",
          "body": "تُعرض حالة الأمر ورد المورد والتسليم والفوترة منفصلة ولا تُدمج، فيتقدم أحدها دون أن يحجب البقية."
        },
        "responses": {
          "title": "ردود المورد",
          "body": "ما أبلغك به المورد ومتى: التأكيدات ومواعيد التسليم وحالات النقص والأسئلة والشحنات."
        },
        "receipts": {
          "title": "الاستلامات",
          "body": "ما استُلم مقابل كل بند، وكل استلام مرتبط بالإصدار الذي استُلم عليه. الاستلامات أدلة على التسليم."
        },
        "versions": {
          "title": "سجل الإصدارات",
          "body": "كل إصدار صادر مستند ثابت، والإصدار الجديد لا يعيد كتابة القديم. فتح المستند يُسجَّل في سجل التدقيق، لذلك لا تفتحه الجولة."
        },
        "actions": {
          "title": "تغيير الأمر",
          "body": "التعديل ينشئ إصدارًا جديدًا ويُبقي القديم محفوظًا، والإلغاء يحرّر الالتزام المتبقي فقط. ويطلب كلٌّ منهما سببًا ويعرض عواقبه قبل تنفيذ أي شيء. وأنت من يُجري هذه التغييرات."
        },
        "actionsAbsent": "لا ينطبق على هذا الأمر في حالته الحالية أيٌّ من التغييرات التي يتيحها دورك؛ فالأمر المكتمل أو الملغى مثلًا لا يمكن تغييره. وعندما ينطبق تغيير، يظهر مع الأمر."
      },
      "T07": {
        "title": "سجّل استلام التسليم",
        "summary": "التسليمات التي تنتظرك، وما تبقى منها، والإبلاغ عن خلل، والإقفال بنقص.",
        "openOrder": "افتح أمرًا من قائمة الاستلام، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "queue": {
          "title": "تسليمات بانتظار الاستلام",
          "body": "الأوامر المتوقع وصولها إلى وحدات الشراء التابعة لك وتنتظر تسجيل الاستلام. افتح أحدها لتسجيل ما وصل."
        },
        "facts": {
          "title": "الأمر الذي تستلمه",
          "body": "الإصدار الذي تستلم عليه، وجهة التسليم وموعده المتوقع، وشحنة المورد إن أبلغ عنها."
        },
        "lines": {
          "title": "المطلوب والمقبول والمتبقي",
          "body": "يعرض كل بند الكمية المطلوبة وما قُبل سابقًا وما تبقى. أدخل ما وصل اليوم، وإن كان في بند خلل فاستخدم «الإبلاغ عن خلل» عليه."
        },
        "delivery": {
          "title": "تفاصيل التسليم",
          "body": "إشعار تسليم المورد وملاحظاتك على هذا التسليم. وإن لم يصل تسليم كان متوقعًا، فأبلغ عن تأخره من هنا."
        },
        "history": {
          "title": "سجل الاستلام",
          "body": "كل استلام سُجّل على هذا الأمر. لا يمكن تعديل الاستلام بعد تسجيله، والتصحيح يكون باستلام إضافي."
        },
        "closeShort": {
          "title": "الإقفال بنقص",
          "body": "حين لا يُتوقع وصول المتبقي ضمن هذا الأمر، أقفله بنقص مع ذكر السبب. يحرّر ذلك الميزانية المحجوزة له ولا يمكن التراجع عنه، وهو قرار منفصل عن الاستلام."
        },
        "record": {
          "title": "تسجيل الاستلام",
          "body": "«وصل كل شيء بشكل صحيح» يسجّل كل البنود المتبقية كاملة دفعة واحدة، و«تسجيل ما أدخلته» يسجّل ما أدخلته فقط. وأنت من يسجّل الاستلام."
        }
      },
      "T08": {
        "title": "أدلة الفواتير والتقارير",
        "summary": "سجّل فاتورة المورد كدليل، واعرف ما يُكمل الأمر، واعثر على تقاريرك وصفِّها.",
        "openOrder": "افتح أمر شراء، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "openReport": "افتح تقريرًا من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "invoices": {
          "title": "فواتير الموردين",
          "body": "الفواتير المسجّلة على هذا الأمر. يحفظها فيدلِن كدليل، ولا يصدرها ولا يعتمدها ولا يدفعها."
        },
        "recordInvoice": {
          "title": "تسجيل فاتورة",
          "body": "يفتح نموذجًا قصيرًا لرقم فاتورة المورد وتاريخها ومبالغها وملفها بصيغة PDF. لا تفتح الجولة النموذج ولا ترفع أي ملف."
        },
        "completion": {
          "title": "متى يكتمل الأمر",
          "body": "يكتمل سجل الشراء حين تُستلم كل الكميات أو تُقفل بنقص، وتُسجَّل فاتورة واحدة على الأقل."
        },
        "audit": {
          "title": "سجل التدقيق",
          "body": "من فعل ماذا ومتى في منشأتك. استخدم عوامل التصفية لتضييق النتائج."
        },
        "reports": {
          "title": "تقاريرك",
          "body": "التقارير التي يتيحها لك دورك، تُحسب مباشرة من السجلات ضمن نطاقك. افتح أحدها لترى أرقامه."
        },
        "filters": {
          "title": "تصفية التقرير",
          "body": "اختر الفترة والمواقع وطريقة التجميع، فتتغير الأرقام مباشرة."
        },
        "export": {
          "title": "التصدير",
          "body": "يصدّر ما تراه بعوامل التصفية والنطاق نفسها، ويُسجَّل كل تصدير في سجل التدقيق. وأنت من يصدّر."
        }
      },
      "T09": {
        "title": "الإدارة والجاهزية للتشغيل",
        "summary": "الجاهزية للتشغيل، والاستيراد، والمستخدمون، والأدوار، وقواعد الاعتماد، والميزانيات.",
        "readiness": {
          "title": "الجاهزية للتشغيل",
          "body": "تُفحص مباشرة مقابل إعداداتك الحالية، فتعرض ما أُعدّ فعلًا وما هو متبقٍّ."
        },
        "import": {
          "title": "استيراد البيانات الرئيسية",
          "body": "ارفع ملف CSV أو Excel. يُفحص أولًا ولا يُنشأ شيء حتى تعتمده. ولا تختار الجولة أي ملف."
        },
        "importHistory": {
          "title": "سجل الاستيراد",
          "body": "كل ملف فُحص أو استُورد مع نتيجته. افتح أحدها لترى صفوفه."
        },
        "users": {
          "title": "المستخدمون",
          "body": "الأشخاص وأدوارهم ونطاقاتهم، أي ما يمكن لكل شخص أن يراه ويفعله."
        },
        "roles": {
          "title": "الأدوار",
          "body": "مجموعات صلاحيات مسمّاة. يمنح الدور الصلاحيات المدرجة فيه فقط."
        },
        "rules": {
          "title": "قواعد الاعتماد",
          "body": "تُفحص بترتيب الأولوية، الرقم الأصغر أولًا، بمستويين بشريين للاعتماد كحد أقصى. ويعرض المحاكي القاعدة التي سيخضع لها الطلب."
        },
        "budgets": {
          "title": "الميزانيات",
          "body": "الرقابة على الإنفاق حسب وحدة الشراء والفئة والفترة. الرقابة تنبيهية: التجاوز لا يمنع الطلب بل يغيّر مسار اعتماده."
        }
      },
      "T11": {
        "title": "الرد على طلب عرض",
        "summary": "دعواتك، وما يطلبه المشتري، وعرضك ومدة سريان سعره، والمستندات، وإرسال عرض السعر أو تعديله.",
        "openEnquiry": "افتح طلب عرض من القائمة، ثم اختر «متابعة» من المساعدة والجولات الإرشادية.",
        "list": {
          "title": "طلبات العروض",
          "body": "لا تظهر إلا طلبات العروض التي دعاك إليها هذا المشتري، ولا ترى الموردين الآخرين ولا أسعارهم. افتح أحدها للرد."
        },
        "header": {
          "title": "طلب العرض",
          "body": "مرجعه، وحالة دعوتك، وهل هو مفتوح لاستقبال العروض، وموعد الرد، والعملة، والمشتري."
        },
        "requirement": {
          "title": "المطلوب",
          "body": "البنود والكميات وشروط المشتري. ويُدخل سعر الوحدة دون الضريبة."
        },
        "offer": {
          "title": "عرضك",
          "body": "نسبة الضريبة، ومدة سريان السعر (وهي غير موعد الرد)، وأقل كمية للطلب، ومدة التوريد، والتوفر. لا يُحفظ شيء حتى ترسل. وبعد إغلاق الطلب يحلّ إشعار محلّ هذا النموذج."
        },
        "documents": {
          "title": "المستندات",
          "body": "تُرفق مستندات PDF، حتى 10 ميجابايت لكل منها، بعرضك بعد إرساله."
        },
        "currentOffer": {
          "title": "عرضك الحالي",
          "body": "بعد إرسال عرض السعر يظهر عرضك الحالي في هذه الصفحة مع رقم مراجعته وأسعاره وشروطه. «البدء من عرضي الحالي» ينسخه إلى النموذج، ولا تضغطه الجولة."
        },
        "send": {
          "title": "إرسال عرض السعر",
          "body": "الإرسال يشارك هذا العرض مع المشتري. إنه عرض وليس طلب شراء، ويمكنك إرسال عرض معدّل حتى موعد الرد. ويصبح الإرسال متاحًا حين يُسعَّر كل بند. وأنت من يرسله."
        }
      }
    }
  }
}
